import styled from "styled-components";
import { style as styleConfig } from "../../../config";
export default styled.div `
  font-weight: bold;
  font-size: ${({ small = true }) => (small ? "0.8em" : "1em")};
  color: ${styleConfig.colors.primary};
  margin-top: 0.5rem;
`;
